import script from "./StatsMileMonthQuery.vue?vue&type=script&lang=js"
export * from "./StatsMileMonthQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__